import login from './login'

const state = {
  info: {},
}

const getters = {
}

const mutations = {
  setInfo (state, value) {
    state.info = value
  }
}

const actions = {
  search ({ state, commit, rootState }, params) {
    return rootState.axios.get('/user/v1frontend/user/search', {params})
  },
  create ({ state, commit, rootState }, params) {
    return rootState.axios.post('/user/v1frontend/user/create', params)
  },
  update ({ state, commit, rootState }, params) {
    return rootState.axios.post('/user/v1frontend/user/update', params)
  },
  profile ({ state, commit, rootState }, params) {
    return rootState.axios.post('/user/v1frontend/user/profile', params).then(res => {
      commit('setInfo', res.data.model)
      return res
    })
  },
  logout ({ state, commit, rootState }, params) {
    localStorage.removeItem('accessToken')
    location.href = '#/login'
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  modules: {
    login,
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/user/index.js